/**
 * Collection Filter Headings - Desktop functionality
 * Handles clicking individual filter headings to open specific filter groups
 */

(function () {
    'use strict';

    let observer = null;

    // Update filter heading counts dynamically
    function updateFilterHeadingCounts() {
        console.log('🔢 updateFilterHeadingCounts() called');
        
        const filterHeadingButtons = document.querySelectorAll('[data-filter-heading-button]');
        console.log(`   Found ${filterHeadingButtons.length} heading buttons`);
        
        filterHeadingButtons.forEach(button => {
            const filterIndex = parseInt(button.getAttribute('data-filter-index'));
            const filterLabel = button.querySelector('span:first-child')?.textContent || 'Unknown';
            const filterGroups = document.querySelectorAll('[data-filter-group-index]');
            
            console.log(`\n   📋 Processing: ${filterLabel} (index ${filterIndex})`);
            
            // Find the matching filter group
            filterGroups.forEach(group => {
                const groupIndex = parseInt(group.getAttribute('data-filter-group-index'));
                
                if (groupIndex === filterIndex) {
                    // Count checked checkboxes in this group
                    const checkboxes = group.querySelectorAll('input[type="checkbox"]');
                    const checkedCheckboxes = group.querySelectorAll('input[type="checkbox"]:checked');
                    const checkedCount = checkedCheckboxes.length;
                    
                    console.log(`      Total checkboxes: ${checkboxes.length}`);
                    console.log(`      Checked: ${checkedCount}`);
                    
                    if (checkedCount > 0) {
                        checkedCheckboxes.forEach(cb => {
                            console.log(`        ✓ ${cb.value}`);
                        });
                    }
                    
                    // Find or create the count span
                    let countSpan = button.querySelector('.filter-heading__count');
                    
                    if (checkedCount > 0) {
                        if (!countSpan) {
                            // Create count span if it doesn't exist
                            countSpan = document.createElement('span');
                            countSpan.className = 'filter-heading__count';
                            button.appendChild(countSpan);
                            console.log(`      Created new count span`);
                        }
                        countSpan.textContent = `(${checkedCount})`;
                        console.log(`      ✅ Updated count to: (${checkedCount})`);
                    } else {
                        // Remove count span if count is 0
                        if (countSpan) {
                            countSpan.remove();
                            console.log(`      ❌ Removed count span (0 filters)`);
                        } else {
                            console.log(`      ℹ️  No count span to remove`);
                        }
                    }
                }
            });
        });
        
        console.log('✅ updateFilterHeadingCounts() complete\n');
    }

    function initFilterHeadingButtons() {
        const filterHeadingButtons = document.querySelectorAll('[data-filter-heading-button]');
        const filterSidebar = document.querySelector('[data-collection-sidebar]');

        if (!filterHeadingButtons.length || !filterSidebar) return;
        
        // Update counts on initialization
        updateFilterHeadingCounts();

        // Function to expand a specific filter group and collapse others
        function setActiveFilterGroup(targetIndex) {
            // Re-query filter groups each time to ensure we have fresh DOM references
            const filterGroups = document.querySelectorAll('[data-filter-group-index]');

            filterGroups.forEach((group) => {
                const heading = group.querySelector('[data-collection-sidebar-heading]');
                const content = heading ? heading.nextElementSibling : null;
                const groupIndex = parseInt(group.getAttribute('data-filter-group-index'));

                if (heading && content) {
                    if (groupIndex === targetIndex) {
                        // Expand the target filter group
                        heading.classList.add('is-active');
                        content.style.display = 'block';
                    } else {
                        // Collapse other groups
                        heading.classList.remove('is-active');
                        content.style.display = 'none';
                    }
                }
            });
        }

        // Store which filter was clicked
        let clickedFilterIndex = null;

        // Handle filter heading button clicks - DON'T prevent theme's toggle behavior
        filterHeadingButtons.forEach(button => {
            button.addEventListener('click', function (e) {
                clickedFilterIndex = parseInt(this.getAttribute('data-filter-index'));

                // Let the theme's ariaToggle handle the sidebar opening
                // We just track which filter was clicked and expand it when sidebar opens

                // Set filter groups after a delay to let sidebar open
                setTimeout(function () {
                    if (clickedFilterIndex !== null) {
                        setActiveFilterGroup(clickedFilterIndex);
                    }
                }, 100);

                setTimeout(function () {
                    if (clickedFilterIndex !== null) {
                        setActiveFilterGroup(clickedFilterIndex);
                    }
                }, 400);
            });
        });

        // Watch for sidebar opening/closing
        if (observer) {
            observer.disconnect();
        }

        observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const sidebar = mutation.target;

                    // When sidebar is opening or opened
                    if (sidebar.classList.contains('expanded') || sidebar.classList.contains('expanding')) {
                        if (clickedFilterIndex !== null) {
                            // Expand the clicked filter group
                            setTimeout(function () {
                                setActiveFilterGroup(clickedFilterIndex);
                            }, 50);
                        }
                    }

                    // When sidebar closes, clear the clicked filter
                    if (!sidebar.classList.contains('expanded') && !sidebar.classList.contains('expanding')) {
                        clickedFilterIndex = null;
                    }
                }
            });
        });

        observer.observe(filterSidebar, { attributes: true });

        // Initialize filter groups state on desktop
        if (window.innerWidth >= 750) {
            const filterGroups = document.querySelectorAll('[data-filter-group-index]');
            filterGroups.forEach((group) => {
                const heading = group.querySelector('[data-collection-sidebar-heading]');
                if (heading) {
                    // Collapse all groups initially on desktop for slide-out
                    if (filterSidebar.hasAttribute('data-collection-sidebar-slide-out')) {
                        heading.classList.remove('is-active');
                        const content = heading.nextElementSibling;
                        if (content) {
                            content.style.display = 'none';
                        }
                    }
                }
            });
        }
    }

    // Initialize on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFilterHeadingButtons);
    } else {
        // DOM already loaded
        setTimeout(initFilterHeadingButtons, 100);
    }

    // Re-initialize on Shopify section load
    document.addEventListener('shopify:section:load', function () {
        setTimeout(initFilterHeadingButtons, 100);
    });

    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initFilterHeadingButtons, 250);
    });
    
    // Listen for checkbox changes to update counts
    document.addEventListener('change', function(e) {
        if (e.target.matches('[data-collection-filters-form] input[type="checkbox"]')) {
            // Update counts when any filter checkbox changes
            setTimeout(updateFilterHeadingCounts, 100);
        }
    });
    
    // Listen for filter clear/remove button clicks (AJAX filter updates)
    document.addEventListener('click', function(e) {
        const filterUpdateLink = e.target.closest('[data-filter-update-url]');
        if (filterUpdateLink) {
            console.log('🔄 Filter clear/remove clicked, will update counts after page updates...');
            // Update counts after AJAX content loads - multiple attempts with longer delays
            setTimeout(updateFilterHeadingCounts, 800);
            setTimeout(updateFilterHeadingCounts, 1500);
            setTimeout(updateFilterHeadingCounts, 2500);
        }
    });
    
    // Also update counts when filter drawer content changes (AJAX filtering)
    const filterForm = document.querySelector('[data-collection-filters-form]');
    if (filterForm) {
        const formObserver = new MutationObserver(function() {
            updateFilterHeadingCounts();
        });
        
        formObserver.observe(filterForm, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['checked']
        });
    }
})();
